module.exports = __webpack_public_path__ + "img/banner-cn.06b1dfe4.png";